export default __webpack_public_path__ + "static/media/ServerSideErrorMobile.50c10a73.svg";